import { render, staticRenderFns } from "./CashDeliveryAdviceAdd.vue?vue&type=template&id=397ba050"
import script from "./CashDeliveryAdviceAdd.vue?vue&type=script&lang=js"
export * from "./CashDeliveryAdviceAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports